module.exports = __webpack_public_path__ + "assets/img/t13.bd0b3164.png";